/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Health_DataInputs */

const en_footer_health_data = /** @type {(inputs: Footer_Health_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consumer health data`)
};

const pl_footer_health_data = /** @type {(inputs: Footer_Health_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dane o zdrowiu konsumentów`)
};

/**
* | output |
* | --- |
* | "Consumer health data" |
*
* @param {Footer_Health_DataInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const footer_health_data = /** @type {((inputs?: Footer_Health_DataInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Health_DataInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_footer_health_data(inputs)
	return en_footer_health_data(inputs)
});